// ─────────────────────────────────────────────────────────────────────────────
// NotificationPanel — the dropdown content: header (title + live indicator +
// "Mark all read"), then the scrollable list of notification rows. Purely
// presentational; all data + actions come from the NotificationsProvider.
// ─────────────────────────────────────────────────────────────────────────────
import { useNotifications } from "../../context/NotificationsContext";
import { formatRelative } from "../../services/usersService";
import styles from "./notifications.module.css";

// Severity → accent colour (matches the Nodes STATUS_CONFIG palette).
const SEVERITY_COLOR = {
  info:     "#00e87a",
  warning:  "#ffc542",
  critical: "#ff4560",
};

export default function NotificationPanel() {
  const { notifications, unreadCount, connected, loading, markRead, markAllRead } =
    useNotifications();

  return (
    <div className={styles.panel} role="dialog" aria-label="Notifications">
      <div className={styles.header}>
        <span className={styles.title}>
          Notifications
          <span
            className={styles.conn}
            data-on={connected}
            title={connected ? "Live" : "Reconnecting…"}
          />
        </span>
        <button
          className={styles.markAll}
          onClick={markAllRead}
          disabled={unreadCount === 0}
        >
          Mark all read
        </button>
      </div>

      <div className={styles.list}>
        {loading ? (
          <div className={styles.empty}>Loading…</div>
        ) : notifications.length === 0 ? (
          <div className={styles.empty}>You’re all caught up.</div>
        ) : (
          notifications.map((n) => (
            <button
              key={n.id}
              className={`${styles.item} ${n.read ? "" : styles.itemUnread}`}
              onClick={() => { if (!n.read) markRead(n.id); }}
            >
              <span
                className={styles.dot}
                style={{ background: SEVERITY_COLOR[n.severity] || SEVERITY_COLOR.info }}
              />
              <span className={styles.body}>
                <span className={styles.itemTitle}>{n.title}</span>
                <span className={styles.itemMsg}>{n.message}</span>
                <span className={styles.time}>{formatRelative(n.createdAt)}</span>
              </span>
              {!n.read && <span className={styles.unreadPip} aria-label="unread" />}
            </button>
          ))
        )}
      </div>
    </div>
  );
}
